module.exports = __webpack_public_path__ + "static/media/SiteNavIcon.ee28981f.svg";